import { useContext } from 'react'
import { DialogTexts } from '../../utils/constants'
import { ContainerContext } from '../../yuno-dashboard-container-mfe'
import { useSnackbar } from './hooks/snackbar/snackbar.hook'
import { statusEnum } from '../../utils/enums'

const useHandleSwitch = ({
  allowed,
  handleOpenDialog,
  setTitle,
  setButtons,
  setContent,
  response,
  t,
}) => {
  const { onOpenSnackbar } = useSnackbar()
  const {
    organization,
    toggleEnvironment,
    handleActivation,
    organizations,
    organizationCodeStaff,
  } = useContext(ContainerContext)
  const acceptButton = () => {
    handleActivation()
    handleOpenDialog()
    onOpenSnackbar('Successful account activation request.', 'success')
  }
  const cancelButton = () => {
    setTitle('')
    setContent('')
    handleOpenDialog()
  }
  const handleSwitch = () => {
    const organizationSelected = organizations.data?.find(
      (item) => item.code === organizationCodeStaff,
    )

    if (organizationSelected) {
      if (organizationSelected.status !== statusEnum[1]) {
        setButtons([
          {
            variant: 'primary',
            label: 'Got it!',
            size: 'small',
            event: handleOpenDialog,
          },
        ])
      } else {
        setButtons([
          {
            variant: 'tertiary',
            label: 'Cancel',
            size: 'small',
            allowed: true,
            event: cancelButton,
          },
          {
            variant: 'primary',
            label: 'Activate account',
            size: 'small',
            allowed: allowed,
            event: acceptButton,
          },
        ])
      }
      if (!!response.data && organizationSelected.status !== statusEnum[0]) {
        setTitle(DialogTexts.DIALOG_TITLE_LIVE_MODE)
        setContent(
          organization.status == statusEnum[1]
            ? response.data.DIALOG_INACTIVE
            : response.data.DIALOG_VALIDATION,
        )
      }
      if (organizationSelected.status !== statusEnum[0]) {
        handleOpenDialog()
      } else {
        toggleEnvironment()
      }
      return
    }

    if (organization.status !== statusEnum[1]) {
      setButtons([
        {
          variant: 'primary',
          label: t('dialogs.pending.done'),
          size: 'small',
          event: handleOpenDialog,
        },
      ])
    } else {
      setButtons([
        {
          variant: 'tertiary',
          label: t('cancel'),
          size: 'small',
          event: cancelButton,
        },
        {
          variant: 'primary',
          label: t('dialogs.inactive.done'),
          size: 'small',
          event: acceptButton,
        },
      ])
    }
    if (!!response.data && organization.status !== statusEnum[0]) {
      setTitle(
        organization.status == statusEnum[1]
          ? t('dialogs.inactive.title')
          : t('dialogs.pending.title'),
      )
      setContent(
        organization.status == statusEnum[1]
          ? t('dialogs.inactive.body')
          : t('dialogs.pending.body'),
      )
    }
    if (organization.status !== statusEnum[0]) {
      handleOpenDialog()
    } else {
      toggleEnvironment()
    }
  }
  return handleSwitch
}
export default useHandleSwitch
